module.exports = __webpack_public_path__ + "img/no_preview_2.d37cf847.png";